<template>
  <v-container class="content ma-0 pa-0">
    <v-row>
      <v-col cols="12">
        <v-card
          :style="
            $vuetify.breakpoint.xs
              ? 'padding: 12px; margin: 4px'
              : 'padding: 18px; margin: 18px; margin-top: 6px'
          "
        >
          <v-row
            v-if="loading"
            class="fill-height ma-5 flex-column"
            align="center"
            justify="center"
          >
            <v-progress-circular
              style="margin-bottom: 8px"
              :size="80"
              color="teal"
              indeterminate
            />
            <span style="font-size: 18px">Carregando...</span>
          </v-row>
          <v-row v-if="!loading" align="center">
            <v-col
              v-if="user.CodRole === 3"
              class="pa-1"
              cols="12"
              sm="6"
              md="3"
            >
              <v-select
                v-model="agroindustria"
                :rules="[v => !!v || 'Obrigatório']"
                :items="agroindustrias"
                color="teal"
                item-text="display_nome"
                return-object
                label="Agroindústria"
                prepend-icon="mdi-factory"
                no-data-text="Sem agroindústrias"
                multiple
                required
              />
            </v-col>
            <v-col class="pa-1" cols="12" sm="6" md="3">
              <v-menu
                v-model="menuDataIni"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                    :value="moment(dataInicio).format('DD/MM/YYYY')"
                    label="Data Inicial"
                    prepend-icon="mdi-calendar"
                    color="teal"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="dataInicio"
                  style="margin: 0px"
                  :max="dataFim"
                  color="teal"
                  locale="pt-br"
                  @input="menuDataIni = false"
                />
              </v-menu>
            </v-col>
            <v-col class="pa-1" cols="12" sm="6" md="3">
              <v-menu
                v-model="menuDataFim"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                    :value="moment(dataFim).format('DD/MM/YYYY')"
                    color="teal"
                    label="Data Final"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="dataFim"
                  :min="dataInicio"
                  :max="dataLimite"
                  color="teal"
                  locale="pt-br"
                  @input="menuDataFim = false"
                />
              </v-menu>
            </v-col>
            <v-col
              class="pa-1 mb-4"
              cols="12"
              sm="6"
              :md="user.CodRole === 3 ? '3' : '6'"
            >
              <v-row justify="end" align="center">
                <!-- <v-btn
                  v-if="!construindoGraficos && dadosCarregados"
                  :loading="exportandoPdf"
                  style="margin-right: 12px; border-radius: 8px"
                  color="#28416a"
                  dark
                  title="Exportar PDF"
                  @click="exportarPdf"
                >
                  <v-icon style="padding-right: 6px">
                    mdi-file-pdf
                  </v-icon>
                  <span style="font-size: 16px; font-weight: 500"> Exportar </span>
                </v-btn> -->
                <v-btn
                  :disabled="construindoGraficos"
                  style="color: white; border-radius: 8px"
                  color="green darken-1"
                  @click="geraDashboard"
                >
                  <span style="font-size: 16px; font-weight: 500">Gerar</span>
                </v-btn>
              </v-row>
            </v-col>
            <template>
              <v-container v-if="!loading">
                <v-card color="#28416a" class="white--text pa-3">
                  <v-row
                    v-if="construindoGraficos && !loading"
                    class="fill-height ma-5 flex-column"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      style="margin-bottom: 8px"
                      :size="80"
                      color="white"
                      indeterminate
                    />
                    <span style="font-size: 18px">Construindo Gráfico...</span>
                  </v-row>
                  <v-row
                    v-else-if="!construindoGraficos && dadosCarregados"
                    class="fill-height flex-column"
                    justify="center"
                  >
                    <div>
                      <v-col class="float-left" style="padding-top: 24px">
                        <span style="font-size: 16px; font-weight: 400"
                          ><strong>Período:</strong>
                          {{
                            moment(dataInicio).format('DD/MM/YYYY') +
                            ' à ' +
                            moment(dataFim).format('DD/MM/YYYY')
                          }}</span
                        >
                        <br />
                      </v-col>
                      <v-col class="align-right">
                        <div class="d-flex align-center justify-end">
                          <v-btn
                            :loading="exportandoPdf"
                            icon
                            large
                            color="white"
                            title="Exportar PDF"
                            @click="exportarPdf"
                          >
                            <v-icon>mdi-file-pdf</v-icon>
                          </v-btn>
                        </div>
                      </v-col>
                    </div>
                  </v-row>
                  <v-row v-else>
                    <span
                      style="font-size: 14px; text-align: center; width: 100%"
                      >Nenhuma informação carregada.</span
                    >
                  </v-row>
                </v-card>
              </v-container>
              <v-container>
                <v-row />
              </v-container>
            </template>
          </v-row>
          <template id="dashboard-charts">
            <v-container v-if="!construindoGraficos && dadosCarregados">
              <v-row id="indicadores-dashboard">
                <v-col
                  style="
                    max-height: 90px;
                    margin: 0px;
                    padding: 0px 5px 100px 0px;
                  "
                  cols="12"
                  sm="6"
                  lg="6"
                  xl="3"
                >
                  <v-card class="ma-3" outlined>
                    <v-list-item>
                      <v-icon large center> mdi-animation </v-icon>
                      <v-list-item-content class="ml-6">
                        <v-list-item-title class="display-2 mb-1">
                          Número de Diagnósticos
                        </v-list-item-title>
                        <v-list-item-subtitle class="display-1">
                          {{ numDiagnosticos }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-col>
                <v-col
                  style="
                    max-height: 90px;
                    margin: 0px;
                    padding: 0px 5px 100px 0px;
                  "
                  cols="12"
                  sm="6"
                  lg="6"
                  xl="3"
                >
                  <v-card class="ma-3" outlined>
                    <v-list-item>
                      <v-icon large center> mdi-account </v-icon>
                      <v-list-item-content class="ml-6">
                        <v-list-item-title class="display-2 mb-1">
                          Pessoas Consultadas
                        </v-list-item-title>
                        <v-list-item-subtitle class="display-1">
                          {{ pessoasConsultadas }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-col>
                <v-col
                  style="
                    max-height: 90px;
                    margin: 0px;
                    padding: 0px 5px 100px 0px;
                  "
                  cols="12"
                  sm="6"
                  lg="6"
                  xl="3"
                >
                  <v-card class="ma-3" outlined>
                    <v-list-item>
                      <v-icon large center> mdi-arrow-right-bold </v-icon>
                      <v-list-item-content class="ml-6">
                        <v-list-item-title class="display-2 mb-1">
                          Captação Registrada
                        </v-list-item-title>
                        <v-list-item-subtitle class="display-1">
                          {{ captacaoRegistrada }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-col>
                <v-col
                  style="
                    max-height: 90px;
                    margin: 0px;
                    padding: 0px 5px 100px 0px;
                  "
                  cols="12"
                  sm="6"
                  lg="6"
                  xl="3"
                >
                  <v-card class="ma-3" outlined>
                    <v-list-item>
                      <v-icon large center> mdi-account-box-multiple </v-icon>
                      <v-list-item-content class="ml-6">
                        <v-list-item-title class="display-2 mb-1">
                          Média Diagnósticos x Consultor
                        </v-list-item-title>
                        <v-list-item-subtitle class="display-1">
                          {{ mediaDiagConsult }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  v-for="(pergunta, grafBinarios) in binarios"
                  id="idBinarios"
                  ref="refBinarios"
                  :key="grafBinarios * 3 + 7"
                  style="margin: 0px; padding: 0px 15px"
                  cols="12"
                  md="6"
                  sm="12"
                >
                  <v-card outlined class="mt-0 rounded-card pt-1">
                    <v-card-title
                      class="d-flex justify-center align-top subtitle-2"
                      v-text="pergunta.title"
                    />
                    <g-chart
                      type="PieChart"
                      :data="pergunta.binariosData"
                      :options="pergunta.binariosOptions"
                    />
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th class="text-left">Valores</th>
                          <th class="text-right">Respostas</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="caption">Sim</td>
                          <td class="text-right caption">
                            {{ pergunta.binariosData[1][1] }}
                          </td>
                        </tr>
                        <tr>
                          <td class="caption">Não</td>
                          <td class="text-right caption">
                            {{ pergunta.binariosData[2][1] }}
                          </td>
                        </tr>
                        <tr>
                          <td class="caption">Total</td>
                          <td class="text-right caption">
                            {{
                              pergunta.binariosData[2][1] +
                              pergunta.binariosData[1][1]
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-col>
                <v-col
                  v-for="(pergunta, index) in multiplaSelecao"
                  id="idMultiplaSelecao"
                  ref="refMultiplaSelecao"
                  :key="index * 101 + 11"
                  :md="pergunta.flex || 6"
                  sm="12"
                >
                  <v-card outlined class="mt-0 rounded-card pt-1">
                    <v-card-title
                      class="d-flex justify-center align-top subtitle-2"
                      v-text="pergunta.title"
                    />
                    <g-chart
                      type="PieChart"
                      :data="pergunta.multiplaData"
                      :options="pergunta.multiplaOptions"
                    />
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th class="text-left">Valores</th>
                          <th class="text-right">Respostas</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index2) in pergunta.multiplaData"
                          :key="index2 * 179 + 31"
                        >
                          <td v-if="item[0] !== 'Valores'" class="caption">
                            {{ item[0] }}
                          </td>
                          <td
                            v-if="item[1] !== 'Respostas'"
                            class="text-right caption"
                          >
                            {{ item[1] }}
                          </td>
                        </tr>
                        <tr>
                          <td class="caption">Total</td>
                          <td class="text-right caption">
                            {{ calcularTotal(pergunta) }}
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-col>
                <v-col
                  v-for="(pergunta, index) in barrasSelecao"
                  id="idBarras"
                  ref="refBarras"
                  :key="index * 211 + 47"
                  md="12"
                  sm="12"
                >
                  <v-card outlined class="mt-0 rounded-card pt-1">
                    <v-card-title
                      class="d-flex justify-center align-top subtitle-2"
                      v-text="pergunta.title"
                    />
                    <g-chart
                      type="ColumnChart"
                      :data="pergunta.barrasData"
                      :options="pergunta.barrasOptions"
                    />
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapState} from 'vuex'
import survey from '@/utils/survey'
import dashboard from '@/services/DashboardPDF.js'
export default {
  name: 'DashboardN',
  components: {},
  data() {
    return {
      dataLimite: this.moment().toISOString(true).substr(0, 10),
      dataInicio: this.moment()
        .subtract(1, 'months')
        .toISOString(true)
        .substr(0, 10),
      dataFim: this.moment().toISOString(true).substr(0, 10),
      menuDataIni: false,
      menuDataFim: false,
      loading: true,
      construindoGraficos: false,
      dadosCarregados: false,
      agroindustria: null,
      agroindustrias: [],
      arrDiagnostico: [],
      binarios: [],
      multiplaSelecao: [],
      barrasSelecao: [],
      numDiagnosticos: '',
      pessoasConsultadas: '',
      captacaoRegistrada: '',
      mediaDiagConsult: '',
      exportandoPdf: false,
      spreadsBinarios: {
        binariosOptions: {
          colors: ['#1E88E0', '#D32F20'],
          legend: {
            position: 'bottom',
          },
          chartArea: {top: '7%', height: '75%', width: '100%'},
        },
      },
      spreadsMultipla: {
        multiplaOptions: {
          legend: {
            position: 'bottom',
            align: 'center',
          },
          chartArea: {top: '7%', height: '75%', width: '100%'},
        },
      },
      spreadsBarras: {
        barrasOptions: {
          width: '100%',
          height: 400,
          legend: {position: 'none'},
          chartArea: {width: '90%'},
          bar: {groupWidth: '25%'},
        },
      },
    }
  },
  computed: {
    ...mapState({user: state => state.user}),
  },
  async mounted() {
    if (this.user.CodRole === 3) {
      this.getAgroindustrias()
      this.carregarPrimeiraDashboard()
    } else {
      this.loading = false
      this.geraDashboard()
    }
  },
  methods: {
    complete(index) {
      this.list[index] = !this.list[index]
    },
    calcularTotal: function (index) {
      let sum = 0
      index.multiplaData.forEach(e => {
        if (e[1] !== 'Respostas') {
          sum += e[1]
        }
      })
      return sum
    },
    getAgroindustrias() {
      this.api.get('agroindustria').then(response => {
        this.agroindustrias = response.data
        this.agroindustrias.forEach(el => {
          el.display_nome = el.Nome + ' - ' + el.cnpj
        })
        if (this.user.CodRole === 3) {
          this.agroindustrias.unshift({display_nome: 'Todas'})
        }
        this.loading = false
      })
    },
    geraDashboard() {
      if (this.user.CodRole === 3 && !this.agroindustria.length) {
        this.Swal.fire('', 'Selecione uma agroindústria.', 'error')
      } else {
        this.dadosCarregados = false
        this.construindoGraficos = true
        this.api
          .get('dashboard', {
            params: {
              getAll:
                this.user.CodRole === 3 &&
                this.agroindustria.find(el => el.display_nome === 'Todas')
                  ? 1
                  : 0,
              cnpj:
                this.user.CodRole === 3
                  ? this.agroindustria.map(el => el.cnpj)
                  : [this.user.agroindustria.cnpj],
              data_inicio: this.dataInicio,
              data_fim: this.dataFim,
            },
          })
          .then(response => {
            this.arrDiagnostico = response.data
            if (this.arrDiagnostico.length === 0) {
              this.construindoGraficos = false
              this.Swal.fire(
                'Alerta',
                'Nenhuma informação foi encontrada neste período.',
                'info',
              )
            } else {
              this.inserirDados()
              this.construindoGraficos = false
              this.dadosCarregados = true
            }
          })
          .catch(() => {
            this.construindoGraficos = false
            this.Swal.fire(
              'Alerta',
              'Nenhuma informação foi encontrada neste período.',
              'info',
            )
          })
      }
    },
    inserirDados() {
      this.binarios = []
      this.multiplaSelecao = []
      this.barrasSelecao = []
      this.numDiagnosticos = ''
      this.pessoasConsultadas = ''
      this.captacaoRegistrada = ''
      this.mediaDiagConsult = ''
      this.numDiagnosticos = this.arrDiagnostico.numero_diagnosticos.toString()
      this.pessoasConsultadas = this.arrDiagnostico.pessoas_consultadas.toString()
      this.captacaoRegistrada =
        this.arrDiagnostico.producao_registrada + ' L/dia'.toString()
      this.mediaDiagConsult = this.arrDiagnostico.media_diag_consult.toString()
      for (let i = 0; i < survey.length; i++) {
        if (survey[i].questionType === 'SelectionGroup') {
          if (survey[i].questionId in this.arrDiagnostico) {
            this.binarios.push({
              binariosData: [
                ['Sim', 'Não'],
                ['Sim', this.arrDiagnostico[survey[i].questionId].sim],
                ['Não', this.arrDiagnostico[survey[i].questionId].nao],
              ],
              title: survey[i].questionText,
              ...this.spreadsBinarios,
            })
          }
        } else if (survey[i].questionType === 'MultipleSelectionGroup') {
          if (survey[i].questionId in this.arrDiagnostico) {
            if (survey[i].questionId in this.arrDiagnostico) {
              if (Object.keys(survey[i].options).length <= 4) {
                const valorDiagnostico = this.arrDiagnostico[
                  survey[i].questionId
                ]
                this.multiplaSelecao.push({
                  multiplaData: survey[i].options.map(function (item) {
                    return [
                      item.optionText,
                      valorDiagnostico[item.optionText] || 0,
                    ]
                  }),
                  title: survey[i].questionText,
                  ...this.spreadsMultipla,
                })
              } else {
                const valorDiagnostico = this.arrDiagnostico[
                  survey[i].questionId
                ]
                this.barrasSelecao.push({
                  barrasData: survey[i].options.map(function (item) {
                    return [
                      item.optionText,
                      valorDiagnostico[item.optionText] || 0,
                    ]
                  }),
                  title: survey[i].questionText,
                  ...this.spreadsBarras,
                })
              }
            }
          }
        }
      }
      this.multiplaSelecao.forEach(item => {
        item.multiplaData.unshift(['Valores', 'Respostas'])
      })
      this.barrasSelecao.forEach(item => {
        item.barrasData.unshift(['Valores', 'Respostas'])
      })
    },
    carregarPrimeiraDashboard() {
      this.agroindustria = [{display_nome: 'Todas'}]
      this.geraDashboard()
    },
    async exportarPdf() {
      this.exportandoPdf = true
      const informacoes = [
        'Agroindústria: ' +
          (this.user.CodRole === 3
            ? this.agroindustria.find(el => el.display_nome === 'Todas')
              ? 'Todas'
              : this.agroindustria.reduce(
                  (acc, curr, index, arr) =>
                    acc +
                    curr.display_nome +
                    (arr.length - 1 === index ? '' : ', '),
                  '',
                )
            : this.user.agroindustria.Nome),
        'Período das consultas: ' +
          this.moment(this.dataInicio).format('DD/MM/YYYY') +
          ' à ' +
          this.moment(this.dataFim).format('DD/MM/YYYY'),
        'Data do relatório: ' + this.moment().format('DD/MM/YYYY'),
      ]
      const colsIndicadores = ['Indicador', 'Resposta']
      const rowsIndicadores = []
      const colsBinarios = ['Pergunta', 'Sim', 'Não']
      const rowsBinarios = []
      const multiplaItems = []
      const colsMultipla = ['Pergunta', 'Resposta', 'Quantidade']
      const rowsMultipla = []
      const barrasItems = []
      const colsBarras = ['Pergunta', 'Resposta', 'Quantidade']
      const rowsBarras = []
      rowsIndicadores.push(['Número de Diagnósticos', this.numDiagnosticos])
      rowsIndicadores.push(['Pessoas Consultadas', this.pessoasConsultadas])
      rowsIndicadores.push(['Captação Registrada', this.captacaoRegistrada])
      rowsIndicadores.push([
        'Média Diagnósticos x Consultor',
        this.mediaDiagConsult,
      ])
      for (let i = 0; i < survey.length; i++) {
        if (survey[i].questionType === 'SelectionGroup') {
          if (survey[i].questionId in this.arrDiagnostico) {
            rowsBinarios.push([
              survey[i].questionText,
              this.arrDiagnostico[survey[i].questionId].sim,
              this.arrDiagnostico[survey[i].questionId].nao,
            ])
          }
        } else if (survey[i].questionType === 'MultipleSelectionGroup') {
          if (survey[i].questionId in this.arrDiagnostico) {
            if (survey[i].questionId in this.arrDiagnostico) {
              if (Object.keys(survey[i].options).length <= 4) {
                const valorDiagnostico = this.arrDiagnostico[
                  survey[i].questionId
                ]
                multiplaItems.push(
                  survey[i].options.map(function (item) {
                    return [
                      survey[i].questionText,
                      item.optionText,
                      valorDiagnostico[item.optionText] || 0,
                    ]
                  }),
                )
              } else {
                const valorDiagnostico = this.arrDiagnostico[
                  survey[i].questionId
                ]
                barrasItems.push(
                  survey[i].options.map(function (item) {
                    return [
                      survey[i].questionText,
                      item.optionText,
                      valorDiagnostico[item.optionText] || 0,
                    ]
                  }),
                )
              }
            }
          }
        }
      }
      for (let i = 0; i < multiplaItems.length; i++) {
        for (let j = 0; j < multiplaItems[i].length; j++) {
          rowsMultipla.push([
            multiplaItems[i][j][0],
            multiplaItems[i][j][1],
            multiplaItems[i][j][2],
          ])
        }
      }
      for (let i = 0; i < barrasItems.length; i++) {
        for (let j = 0; j < barrasItems[i].length; j++) {
          rowsBarras.push([
            barrasItems[i][j][0],
            barrasItems[i][j][1],
            barrasItems[i][j][2],
          ])
        }
      }
      Promise.resolve(
        dashboard.Dashboard(
          'Relatório Dashboard',
          informacoes,
          colsIndicadores,
          rowsIndicadores,
          colsBinarios,
          rowsBinarios,
          colsMultipla,
          rowsMultipla,
          colsBarras,
          rowsBarras,
          'landscape',
        ),
      ).then(() => {
        this.exportandoPdf = false
      })
    },
  },
}
</script>

<style>
.Underline > .v-input__control > .v-input__slot:before {
  border-style: hidden;
}
.diretor-table
  .v-table__overflow
  .v-datatable
  .v-input
  .v-input__control
  .v-input__slot {
  font: 13.3px Roboto;
}
.diretor-table
  .v-table__overflow
  .v-datatable
  .v-input
  .v-input__control
  .v-text-field__slot
  input {
  color: black;
}
.v-input.positivo .v-input__control .v-text-field__slot input {
  font-weight: 500;
  color: teal !important;
}
.v-input.negativo .v-input__control .v-text-field__slot input {
  font-weight: 500;
  color: #f52b1b !important;
}
.list-diagnostico .v-list-item__title {
  font-weight: 400;
  color: #434343;
}
.list-diagnostico .v-list-item__subtitle {
  color: #28416a !important;
  font-weight: 500;
}
</style>
